import React, { useState } from "react";
import Approutes from "./Routes";
import "./Style.css";
// import "bootstrap/dist/css/bootstrap.min.css";
// import navigation context value
import { CollapseMenu } from "./Helper/HelperContext";
// import global styles
import GlobalStyle from "./Components/Styled/GlobalStyled";
import "antd/dist/antd.min.css";
import "./styles/custom_modal.css";
import GetProgressMonitor from "./Components/Categories/GetProgressMonitorBar";
export default function App() {
  const [collapse, setCollapse] = useState(false);

  return (
    <CollapseMenu.Provider value={{ collapse, setCollapse }}>
      <GlobalStyle />
      <Approutes />

      <GetProgressMonitor />
    </CollapseMenu.Provider>
  );
}
